var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("v-combobox", {
        attrs: {
          items: _vm.logos,
          label: "chọn logo watermark",
          dense: "",
          "append-icon": "",
          "persistent-hint": "",
          "item-text": "title",
          "item-value": "src",
        },
        on: { change: _vm.onLogoChange },
        scopedSlots: _vm._u([
          {
            key: "append-outer",
            fn: function () {
              return [
                _vm.selected &&
                _vm.selected.title !== "none" &&
                !_vm.selected.children
                  ? _c(
                      "v-btn",
                      { attrs: { icon: "" }, on: { click: _vm.editLogo } },
                      [_c("v-icon", [_vm._v("mdi-pencil")])],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-btn",
                  { attrs: { icon: "" }, on: { click: _vm.addLogo } },
                  [_c("v-icon", [_vm._v("mdi-plus")])],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "800", persistent: "" },
          model: {
            value: _vm.values.visible,
            callback: function ($$v) {
              _vm.$set(_vm.values, "visible", $$v)
            },
            expression: "values.visible",
          },
        },
        [
          [
            _c(
              "v-card",
              [
                _c("v-toolbar", { attrs: { color: "primary", dark: "" } }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.selected.index > 0 ? "Sửa logo" : "Thêm mới logo"
                      ) +
                      "\n                "
                  ),
                ]),
                _c(
                  "bot-spinner",
                  {
                    model: {
                      value: _vm.spinner,
                      callback: function ($$v) {
                        _vm.spinner = $$v
                      },
                      expression: "spinner",
                    },
                  },
                  [
                    _c(
                      "v-card-text",
                      [
                        _c(
                          "v-form",
                          {
                            ref: "form",
                            staticClass: "mt-4",
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.submit.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.isValid,
                              callback: function ($$v) {
                                _vm.isValid = $$v
                              },
                              expression: "isValid",
                            },
                          },
                          [
                            _c("bot-upload-images", {
                              ref: "botImg",
                              attrs: { caption: "logo" },
                              model: {
                                value: _vm.selected,
                                callback: function ($$v) {
                                  _vm.selected = $$v
                                },
                                expression: "selected",
                              },
                            }),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        autofocus: "",
                                        label: "Tên logo (1-100)",
                                        rules: [
                                          (value) =>
                                            _vm.vld.text({
                                              field: "tên logo",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.title,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.selected, "title", $$v)
                                        },
                                        expression: "selected.title",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "logo zoom (1-100)",
                                        type: "number",
                                        rules: [
                                          (value) =>
                                            _vm.vld.percentage({
                                              field: "logo zoom",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.resize,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.selected, "resize", $$v)
                                        },
                                        expression: "selected.resize",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Canh lề (1-100)",
                                        type: "number",
                                        rules: [
                                          (value) =>
                                            _vm.vld.percentage({
                                              field: "canh lề",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.margin,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.selected, "margin", $$v)
                                        },
                                        expression: "selected.margin",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Độ mờ (1-100)",
                                        type: "number",
                                        rules: [
                                          (value) =>
                                            _vm.vld.percentage({
                                              field: "độ mờ",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.opacity,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.selected, "opacity", $$v)
                                        },
                                        expression: "selected.opacity",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c("v-row"),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Vĩ độ",
                                        type: "number",
                                        rules: [
                                          (value) =>
                                            _vm.vld.number({
                                              field: "vĩ độ",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.latitudeDegrees,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selected,
                                            "latitudeDegrees",
                                            $$v
                                          )
                                        },
                                        expression: "selected.latitudeDegrees",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Kinh độ",
                                        type: "number",
                                        rules: [
                                          (value) =>
                                            _vm.vld.number({
                                              field: "kinh độ",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.longitudeDegrees,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selected,
                                            "longitudeDegrees",
                                            $$v
                                          )
                                        },
                                        expression: "selected.longitudeDegrees",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Doanh nghiệp",
                                        rules: [
                                          (value) =>
                                            _vm.vld.text({
                                              field: "doanh nghiệp",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.Copyright,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selected,
                                            "Copyright",
                                            $$v
                                          )
                                        },
                                        expression: "selected.Copyright",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Đánh giá",
                                        type: "number",
                                        rules: [
                                          (value) =>
                                            _vm.vld.number({
                                              field: "đánh giá",
                                              min: 1,
                                              max: 5,
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.Rating,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.selected, "Rating", $$v)
                                        },
                                        expression: "selected.Rating",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Bình luận mặc định",
                                        rules: [
                                          (value) =>
                                            _vm.vld.text({
                                              field: "bình luận",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.XPComment,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selected,
                                            "XPComment",
                                            $$v
                                          )
                                        },
                                        expression: "selected.XPComment",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-col",
                                  { attrs: { cols: "6" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Tác giả mặc định",
                                        rules: [
                                          (value) =>
                                            _vm.vld.text({
                                              field: "tác giả",
                                              value,
                                            }),
                                        ],
                                      },
                                      model: {
                                        value: _vm.selected.XPAuthor,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selected,
                                            "XPAuthor",
                                            $$v
                                          )
                                        },
                                        expression: "selected.XPAuthor",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c("v-combobox", {
                                      attrs: {
                                        chips: "",
                                        clearable: "",
                                        label: "Từ khóa",
                                        "append-icon": "",
                                        multiple: "",
                                        solo: "",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "selection",
                                          fn: function ({
                                            attrs,
                                            item: chip,
                                            select,
                                            selected: slt,
                                          }) {
                                            return [
                                              _c(
                                                "v-chip",
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      "input-value": slt,
                                                      close: "",
                                                    },
                                                    on: {
                                                      click: select,
                                                      "click:close": function (
                                                        $event
                                                      ) {
                                                        return _vm.removeKeyword(
                                                          chip
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-chip",
                                                  attrs,
                                                  false
                                                ),
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(chip) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                      model: {
                                        value: _vm.selected.XPKeywords,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.selected,
                                            "XPKeywords",
                                            $$v
                                          )
                                        },
                                        expression: "selected.XPKeywords",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card-actions",
                      { staticClass: "justify-end" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "success darken-1", text: "" },
                            on: { click: _vm.submit },
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v(" mdi-check "),
                            ]),
                            _vm._v(
                              "\n                            Cập nhật\n                        "
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "pink", text: "" },
                            on: {
                              click: function ($event) {
                                _vm.values.visible = false
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { left: "" } }, [
                              _vm._v(" mdi-close "),
                            ]),
                            _vm._v(
                              "\n                            Hủy\n                        "
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/tool/file/tool.file.metadata.logo.vue